// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oy-0";